import { useRef, useState } from "react";

import { useProducts } from "Hooks/useProducts";

import { Button } from "Components/Button";
import { OverlayInputText } from "Components/Form/OverlayInputText";

import { OverlayProductList } from "../OverlayProductList";
import { Container } from "./styles";
import { ProductsFilterState } from "../interface";

interface InputOverlayListProps {
  handleTypeSearch: (search: string) => void;
  handleSearchProducts: () => void;
  filters: ProductsFilterState;
  blockUserInteraction?: boolean;
}

export const InputOverlayProductList = ({
  handleTypeSearch,
  handleSearchProducts,
  blockUserInteraction,
  filters,
}: InputOverlayListProps) => {
  const [overlayOpen, setOverlayOpen] = useState(false);
  const timeout = useRef<NodeJS.Timeout | null>(null);

  const {
    productsList,
    loadingProducts,
    setProductFilters,
    enableData,
    handleClearData,
  } = useProducts({
    enableReq: false,
    queryKey: "overlay-products-list",
    initialFilters: {
      ...filters,
    },
  });

  const toggleOverlay = (status: boolean) => {
    if (blockUserInteraction) return;

    setOverlayOpen(status);
    if (timeout.current) clearInterval(timeout.current);
  };

  const handleDebounce = (search: string) => {
    setProductFilters({
      ...filters,
      search,
    });
    enableData();
  };

  const handleType = (typeSearch: string) => {
    handleTypeSearch(typeSearch);

    if (!typeSearch) {
      handleClearData();
      return;
    }

    if (timeout.current) clearInterval(timeout.current);

    if (typeSearch) {
      timeout.current = setTimeout(() => {
        handleDebounce(typeSearch);
      }, 3000);

      return;
    }
  };

  const onSearchProducts = () => {
    handleSearchProducts();
    setOverlayOpen(false);
    if (timeout.current) clearInterval(timeout.current);
  };

  return (
    <Container>
      <OverlayInputText
        name="searchProducts"
        disabled={blockUserInteraction}
        type="search"
        searchValue={filters.search}
        placeholder="Buscar por nome, código, ou sinônimo"
        onChange={(searchText) => handleType(searchText)}
        setOverlayOpen={toggleOverlay}
        isOverlayOpen={overlayOpen}
      >
        <Button
          transparentHover
          classButton="search-btn"
          onClick={onSearchProducts}
        >
          {" "}
          Buscar
        </Button>
      </OverlayInputText>

      {overlayOpen && (
        <OverlayProductList
          loadingProducts={loadingProducts}
          productsList={productsList}
          hasSearched={!!filters.search}
        />
      )}
    </Container>
  );
};
